import { navigate } from 'gatsby';
import React from 'react';

import Cover, { CoverHeading } from '../Cover/Cover';
import Form from '../UI/Form/Form';
import { Grid, GridItem } from '../UI/Grid/Grid';
import { motion } from '../UI/framer-motion-custom';

const FaqCover = () => {
  function handleKeyUp(e) {
    if (e.keyCode === 13) {
      navigate(`/faqs/?q=${e.target.value}`);
    }
  }

  return (
    <Cover as="nav" isCompact>
      <Grid align="center">
        <GridItem md="9">
          <CoverHeading as={motion.div} isSecondary>
            **Frequently asked** questions
          </CoverHeading>
        </GridItem>
        <GridItem md="3">
          <Form.Input
            label="Search FAQs"
            name="search"
            id="search"
            type="search"
            onKeyUp={handleKeyUp}
            required
          />
        </GridItem>
      </Grid>
    </Cover>
  );
};

export default FaqCover;
